import React from 'react';
import useParsePhoneNumber from '../../../../utils/hooks/useParsePhoneNumber';
import { displayExtensionString, displayPhoneNumber } from '../../../../utils/formatters';

interface Props {
  phone?: number|string|null,
  phone_extn?: number|string|null,
  linkClassName?: string,
  textClassName?: string,
  useSmsLink?: boolean,
  useSimpleDisplay?: boolean,
}

const PhoneNumber: React.FC<Props> = ({
  phone,
  phone_extn,
  linkClassName,
  textClassName,
  useSmsLink,
  useSimpleDisplay,
}) => {
  // If no phone number, exit early
  if (typeof phone !== 'string' || phone === '') {
    return (<></>);
  }

  const {
    isValidPhoneNumber,
    phoneCallHref,
    phoneSmsHref,
  } = useParsePhoneNumber(phone, phone_extn);

  if (useSimpleDisplay) {
    return (
      <span className={textClassName}>
        {displayPhoneNumber(String(phone))}
        {displayExtensionString(phone_extn)}
      </span>
    );
  }

  if (isValidPhoneNumber && useSmsLink && phoneSmsHref) {
    return (
      <a
        className={linkClassName || ''}
        href={phoneSmsHref}
      >
        {displayPhoneNumber(String(phone))}
        {displayExtensionString(phone_extn)}
      </a>
    );
  }

  if (isValidPhoneNumber && !useSmsLink && phoneCallHref) {
    return (
      <a
        className={linkClassName || ''}
        href={phoneCallHref}
      >
        {displayPhoneNumber(String(phone))}
        {displayExtensionString(phone_extn)}
      </a>
    );
  }

  return (
    <p className={textClassName || ''}>
      {displayPhoneNumber(String(phone))}
      {displayExtensionString(phone_extn)}
    </p>
  );
};

export default PhoneNumber;
